<script>
export default {
  name: 'BadgeNew',
}
</script>

<template>
  <span class="BadgeNew">NEW</span>
</template>

<style lang="scss">
  .BadgeNew {
    display: inline-block;
    white-space: nowrap;
    vertical-align: middle;
    padding: 2px 7px;
    text-transform: uppercase;
    border-radius: var(--radius-md);
    font-weight: 600;
    background-color: #0834ff;
    color: white;
    font-size: 10px;
  }
</style>